<template>
  <!-- 运程图解 -->
  <van-tab title="运程图解" name="运程图解">
    <ul class="tab-nav flex-x mg-x sex-txt">
      <li
        class="fe-full"
        :class="sex == 1 ? 'active' : ''"
        @click="openUrl('sx', { sxi, sex: 1, sxy })"
      >
        男命运程
      </li>
      <li
        class="fe-full"
        :class="sex == 0 ? 'active' : ''"
        @click="openUrl('sx', { sxi, sex: 0, sxy })"
      >
        女命运程
      </li>
      <li class="fe-full" @click="openUrl('sx')">返回首页</li>
    </ul>
    <div class="lm-wrap yc-data pds-a" v-if="base">
      <van-row type="flex" align="center">
        <van-col span="8">
          <van-button
            class="skin-bg bdr-none"
            type="warning"
            icon="good-job-o"
            @click="toLanmu('明星推荐')"
            >明星推荐</van-button
          >
        </van-col>
        <van-col span="8" class="sx-box">
          <!-- <img :src="sxObj[sxi]['img']" /> -->
          <div class="sx-pic">
            <van-image
              class="skin-bg"
              width="4.5rem"
              height="4.5rem"
              fit="contain"
              round
              :src="sxObj[sxi]['img']"
              @click="showGrid"
            />
            <div class="sx-fix" v-if="base.sxfix[sxt]">
              {{ base.sxfix[sxt] }}
            </div>
          </div>
          <div class="sx-tag sex-txt">生肖{{ sxt }} ({{ sextArr[sex] }}命)</div>
        </van-col>
        <van-col span="8">
          <van-button
            class="skin-bg bdr-none"
            type="warning"
            icon="exchange"
            @click="showGrid"
            >生肖切换</van-button
          >
        </van-col>
      </van-row>
      <div
        class="zb-bar flex-x"
        v-for="(zb, i) in base.zhibiao"
        :class="zb[2][1] == '吉' ? 'zb-ji' : 'zb-xo'"
        :key="i"
        @click="toLanmu('七星指标', zb[0])"
      >
        <div class="zb-hd fe-m">
          <strong class="zb-fix zbtxt">{{ zb[0] }}</strong>
          <small class="zb-fix zbjx">{{ zb[2] }}</small>
        </div>
        <div class="bar-box fe-full fe-m">
          <span class="tips">{{ zb[1] }}</span>
          <van-progress
            :percentage="zb[3]"
            :pivot-text="zb[3] + '分'"
            :color="zb[2][1] == '吉' ? '#ff4040' : '#000'"
            stroke-width="18"
          />
        </div>
        <div class="flex fe-m mgs-l">
          <van-button
            class="see-btn"
            :color="zb[2][1] == '吉' ? '#ff4040' : '#000'"
            size="mini"
            >查看</van-button
          >
        </div>
      </div>
    </div>
  </van-tab>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  data() {
    return {
      //showGrid: false,
    }
  },
  computed: {
    ...mapState([
      'sxArr',
      'sextArr',
      'sxi',
      'sxy',
      'sex',
      'sxyc',
      'base',
      'gridState'
    ]),
    ...mapGetters(['sxObj']),
    sxt() {
      return this.sxArr[this.sxi] || ''
    }
  },
  methods: {
    toLanmu(tit, tab) {
      this.$emit('to-lanmu', { tit, tab })
    },
    showGrid() {
      this.$store.commit('setGridState', !this.gridState)
    }
  }
}
</script>

<style lang="scss" scoped>
.sx-pic,
.sx-box {
  position: relative;
}
.sx-pic {
  border-radius: 100%;
  overflow: hidden;
  width: 4.5rem;
  height: 4.5rem;
  margin: auto;
}
.sx-fix {
  position: absolute;
  top: 9%;
  left: -23%;
  background: #ff0;
  color: #f00;
  width: 100%;
  transform: rotate(-45deg);
  font-size: 12px;
  line-height: 20px;
}
.sx-tag {
  text-align: center;
  font-size: 14px;
}
.yc-data {
  margin-top: 0;
  padding-top: 30px;
}
.see-btn {
  height: 30px;
  line-height: 30px;
}
.tab-nav {
  padding-top: 10px;
  li {
    background: rgba($color: #ffffff, $alpha: 0.5);
    line-height: 36px;
    border-radius: 3px 3px 0 0;
    margin: 0 1px;
  }
  .active {
    background: #fff;
  }
}
</style>